<template>
  <div>
    <ImgDialogHeader
      :header-txt="page.title"
      :image-url="page.active_image ? page.active_image.url : ''"
    >
      <div class="content prose" v-html="page.template.introductie"/>
    </ImgDialogHeader>

    <wave-content
      hide-header
    >
      <div class="content prose" v-html="page.template.tekst"/>
    </wave-content>
  </div>
</template>

<script>
import ImgDialogHeader from '~/components/headers/ImgDialogHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';

export default {
  components: {WaveContent, ImgDialogHeader},
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
